import ToolBase from '../basic';
import DEFINE from '../define';

export default class Eraser extends ToolBase {

    name = DEFINE.TOOLS.ERASER;

    eraser = null;

    isDown = null;
    origX = null;
    origY = null;

    downPointer = null;
    upPointer = null;

    color = "rgba(80, 238, 231, 0.5)";

    count = 0;

    constructor(parent) {
        super(parent);
    }

    mouseDown(o) {
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        this.isDown = true;
        this.downPointer = pointer;

        this.eraser = new fabric.Rect({
            left: this.downPointer.x,
            top: this.downPointer.y,
            fill: this.color
        });
        this.canvas.add(this.eraser);

        if (o.target) {
            this.canvas.discardActiveObject(o.target);
        }
    }

    mouseUp(o) {
        const self = this;

        this.upPointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        let eraserOCoords = this.eraser.zoomX == 1 ? 
        this.eraser.aCoords
        :this.eraser.oCoords;

        // 選取範圍
        let minX = Math.min(eraserOCoords.tl.x, eraserOCoords.tr.x);
        let maxX = Math.max(eraserOCoords.tl.x, eraserOCoords.tr.x);
        let minY = Math.min(eraserOCoords.tl.y, eraserOCoords.tr.y);
        let maxY = Math.max(eraserOCoords.bl.y, eraserOCoords.br.y);

        this.canvas.getObjects().forEach(object => {
            if (self.eraser.intersectsWithObject(object)) {
                let isEnd = false;
                if (!self.parent.exceptClearTarget.includes(object.toolType) && !self.parent.exceptClearTargetAtAllClear.includes(object.toolType) && object != self.eraser) {
                    object.setCoords();

                    let oCoords = self.eraser.zoomX == 1 ? 
                    object.aCoords
                    : object.oCoords;

                    // 物件範圍
                    let oMinX = Math.min(oCoords.tl.x, oCoords.tr.x);
                    let oMaxX = Math.max(oCoords.tl.x, oCoords.tr.x);
                    let oMinY = Math.min(oCoords.tl.y, oCoords.tr.y);
                    let oMaxY = Math.max(oCoords.bl.y, oCoords.br.y);

                    // 重疊範圍
                    let overlapMinX = Math.max(minX, oMinX);
                    let overlapMaxX = Math.min(maxX, oMaxX);
                    let overlapMinY = Math.max(minY, oMinY);
                    let overlapMaxY = Math.min(maxY, oMaxY);

                    for (let i = 0; i <= (overlapMaxX - overlapMinX); i++) {
                        for (let j = 0; j <= (overlapMaxY - overlapMinY); j++) {
                            if (!self.canvas.isTargetTransparent(object, overlapMinX + i, overlapMinY + j)) {
                                self.canvas.remove(object);
                                this.count++;

                                isEnd = true;
                                break;
                            }
                        }

                        if (isEnd) break;
                    }
                };
            }
        });

        this.canvas.remove(this.eraser);
        this.isDown = false;
        this.parent.addHistory();
    }

    mouseMove(o) {
        if (!this.isDown) return;
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        this.eraser.set({
            left: (this.downPointer.x > pointer.x) ? Math.abs(pointer.x) : this.eraser.left,
            top: (this.downPointer.y > pointer.y) ? Math.abs(pointer.y) : this.eraser.top,
            width: Math.abs(this.downPointer.x - pointer.x),
            height: Math.abs(this.downPointer.y - pointer.y)
        });

        this.eraser.setCoords();
        this.canvas.renderAll();
    }
}